import { useEffect } from 'react';

const NotFoundPage = () => {
  useEffect(() => {
    // Also exclude the loader when React navigation reaches a missing route.
    const scripts = [...document.querySelectorAll('script[src*="adsbygoogle"], script[src*="googlesyndication"]')];
    scripts.forEach((script) => script.remove());
    return () => {
      if (scripts.length) {
        scripts.forEach((script) => document.head.appendChild(script));
      } else if (!document.querySelector('script[src*="adsbygoogle"]')) {
        // Direct 404 responses have no loader to restore when leaving this page.
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4758713479777111';
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);
      }
    };
  }, []);

  return (
    <>

      <section className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-indigo-600">404</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
          <p className="mt-6 text-base leading-7 text-gray-600">Sorry, we couldn’t find the page you’re looking for.</p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/"
              className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Go back home
            </a>
            <a href="/contact" className="text-sm font-semibold text-gray-900">
              Contact support <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
      </section>
    </>
  )
}

export default NotFoundPage
